<template>
  <div class="status_checkbox_group">
    <h3 class="status_checkbox_group--heading">{{ heading }}</h3>

    <div class="pl-50">
      <form-field
        v-for="(status, index) in statuses"
        :key="index"
        class="mb-50"
      >
        <b-checkbox
          v-model="value"
          :key="index"
          :native-value="status.id"
          size="is-small"
          @input="handleInput"
        >
          {{ status.label }}
        </b-checkbox>
      </form-field>
    </div>
  </div>
</template>

<script>
import {FormFieldMixin} from "../form/FormField.mixin";

export default {
  name: "StatusCheckboxGroup",
  mixins: [FormFieldMixin],
  props: {
    value: {},
    heading: {
      type: String,
      default: 'Statuses'
    },
    statuses: {
      type: Array,
      required: true,
    }
  },
  methods: {
    handleInput(val) {
      this.$emit("input", val);
      this.$emit("change", val);
      this.$emit("selected", val);
      this.emitGlobalFieldChangeEvent();
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.status_checkbox_group {
  margin-top: 1rem;

  &--heading {
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
    color: $text-light;
  }
}
</style>
